// Lib
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '../../../../../node_module_clones/react-router';

// Styles
import './CurrentBoardMenuPopup.scss';

const CurrentBoardMenuPopup = (props) => {
    const { currentBoardId } = props;

    return (
        <div className="CurrentBoardMenuPopup">
            <Link className="Button" to={`/report-content/${currentBoardId}`}>
                Report inappropriate content
            </Link>
        </div>
    );
};

CurrentBoardMenuPopup.propTypes = {
    currentBoardId: PropTypes.string,
};

export default CurrentBoardMenuPopup;
